const globalStyle = `
  *, *::before, *::after {
    box-sizing: border-box;
  }
  body {
    background: #fbfbfb;
    color: rgba(0,0,0,.87);
  }

`;

export default globalStyle;
